import { gql, useQuery } from 'urql';
import { InvitationStatusTicketEnum } from './useFetchTicketSegment';

export const GET_TICKETS_BY_CATEGORY_QUERY = gql`
  query GetTicketsByCategory($eventId: Int!, $input: TicketFilter) {
    getTicketsByCategory(eventId: $eventId, input: $input) {
      id
      title
      description
      eventId
      color
      countTicket
      tickets {
        id
        checked
        active
        ticketSegmentId
        smsTicketSent
        smsInviteSent
        checkInTime
        categories {
          title
          color
        }
        checkedBy
        scanType
        smsTicketSent
        emailTicketSent
        smsInviteSent
        emailInviteSent
        invitationStatus
        source
        organizerName
        participant {
          id
          email
          login
          position
          phone
          firstName
          lastName
          avatar
          sortNumber
          active
          surname
          source
          isIndividual
          joinedAt
          leftAt
        }
      }
    }
  }
`;

export interface GetTicketsByCategoryResponse {
  getTicketsByCategory: Category[];
}

export interface Category {
  id: number;
  title: string;
  description: string | null;
  eventId: number;
  color: string | undefined;
  countTicket: number;
  tickets: TicketCategory[];
}

export interface CategoryData {
  title: string;
  color: string | null;
}

export interface TicketCategory {
  id: number;
  checked: boolean;
  active: boolean;
  ticketSegmentId: number | null;
  checkInTime: string | null;
  checkedBy: number | null;
  scanType: string | null;
  smsTicketSent: boolean;
  emailTicketSent: boolean;
  smsInviteSent: boolean;
  emailInviteSent: boolean;
  invitationStatus: InvitationStatusTicketEnum;
  source: string;
  organizerName: string | null;
  categories: CategoryData[];
  participant: UserCategory;
}

export interface UserCategory {
  id: number;
  email: string;
  login: string;
  position: string | null;
  phone: string | null;
  firstName: string;
  lastName: string;
  avatar: string | null;
  sortNumber: number;
  active: boolean;
  surname: string | null;
  source: string | null;
  isIndividual: boolean;
  joinedAt: string | null;
  leftAt: string | null;
}

export const useGetTicketsByCategory = (eventId: number | undefined, pause = false) => {
  const [result, reexecuteQuery] = useQuery<GetTicketsByCategoryResponse>({
    query: GET_TICKETS_BY_CATEGORY_QUERY,
    variables: { eventId },
    pause: !eventId || pause,
    requestPolicy: 'network-only',
  });

  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    refetch: reexecuteQuery,
  };
};
